<form autocomplete="off" class="credential2 auction-form-individual" [formGroup]="timedAuctionForm"
  (submit)="saveTimedIndividualAuction('timed-individual')">
  <!-- ============================================= -->
  <!-- SECTION: Basic Details                         -->
  <!-- ============================================= -->
  <div class="auction-section">
    <div class="auction-section__header">
      <span class="auction-section__icon auction-section__icon--info">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 1.5C4.41 1.5 1.5 4.41 1.5 8s2.91 6.5 6.5 6.5 6.5-2.91 6.5-6.5S11.59 1.5 8 1.5Z"
            stroke="currentColor" stroke-width="1.3" />
          <path d="M8 7.2v4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
          <circle cx="8" cy="5.1" r="0.9" fill="currentColor" />
        </svg>
      </span>
      <div class="auction-section__heading">
        <h4 class="auction-section__title">Basic Details</h4>
        <p class="auction-section__subtitle">Name the auction and choose what's being sold</p>
      </div>
    </div>

    <div class="auction-section__body">
      <div class="form-group">
        <label for="" class="credential2__label w-100">Title</label>
        <input type="text" name="title" formControlName="title" class="credential2__input form-control"
          placeholder="Enter Tile" [class.is-invalid]="
            timedIndividualSubmitted && TimeIndividualControl['title'].errors
          " />
        <div class="invalid-feedback">
          <p>Title can not be blank.</p>
        </div>
      </div>

      <div class="form-group p-1">
        <label for="" class="credential2__label w-100">Item</label>
        <div class="row">
          <div class="col-md-6">
            <ng-select [disabled]="true" [clearable]="false" placeholder="Individual" class="ng-select-container-main"
              formControlName="item1" [loading]="ngSelectLoading" [notFoundText]="notFoundText"
              (change)="getProductInfo($event, false)" (scrollToEnd)="fetchNextPage()" (search)="onSearchInput($event)"
              [class.is-invalid]="
                timedIndividualSubmitted &&
                !timedAuctionForm.controls['item1'].value &&
                !timedAuctionForm.controls['item2'].value
              ">
              <ng-option *ngFor="let item of allIndividualProductList" [value]="item['product_id']">{{ item["name"] }}
              </ng-option>
            </ng-select>
            <div class="invalid-feedback">
              <p>Please select an option from Individual or Batch.</p>
            </div>
          </div>

          <!-- Individual Bulk Select -->
          <div class="col-md-6">
            <ng-select [clearable]="false" placeholder="Batch" class="ng-select-container-main" formControlName="item2"
              (change)="getbatchInfoForIndividual($event, true, 'individual_batch')" [class.is-invalid]="
                timedIndividualSubmitted &&
                !timedAuctionForm.controls['item1'].value &&
                !timedAuctionForm.controls['item2'].value
              ">
              <ng-option *ngFor="let item of batches" [value]="item['product_group_id']">{{ item["group_name"] |
                titlecase }}
              </ng-option>
            </ng-select>
          </div>
        </div>
      </div>

      <div *ngIf="auctionExists">
        <p class="ml-3 text-danger">
          **Some vehicle of Batch are already in auction.
        </p>
      </div>
    </div>
  </div>

  <!-- ============================================= -->
  <!-- SECTION: Schedule                              -->
  <!-- ============================================= -->
  <div class="auction-section">
    <div class="auction-section__header">
      <span class="auction-section__icon auction-section__icon--schedule">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="3" width="12" height="11" rx="2" stroke="currentColor" stroke-width="1.3" />
          <path d="M2 6.5h12" stroke="currentColor" stroke-width="1.3" />
          <path d="M5.2 1.5v3M10.8 1.5v3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
        </svg>
      </span>
      <div class="auction-section__heading">
        <h4 class="auction-section__title">Schedule &amp; Timing</h4>
        <p class="auction-section__subtitle">When bidding opens and the live auction runs</p>
      </div>
    </div>

    <div class="auction-section__body">
      <div class="row">
        <div class="col-md-6">
          <div class="row mx-n2">
            <div class="col-md-6 px-2">
              <div class="form-group">
                <label for="" class="credential2__label w-100">Auction Starts</label>
                <input type="text" name="auction_start_date" formControlName="auction_start_date" placeholder="Date"
                  class="credential2__input form-control" readonly bsDatepicker [bsConfig]="{
                    showWeekNumbers: false,
                    dateInputFormat: 'DD-MM-YYYY'
                  }" [class.is-invalid]="
                    timedIndividualSubmitted &&
                    TimeIndividualControl['auction_start_date'].errors
                  " />
                <div class="invalid-feedback">
                  <p>Auction start date can not be blank.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 px-2">
              <div class="form-group">
                <label for="" class="credential2__label w-100 d-none d-md-inline-block">
                  &nbsp;
                </label>
                <input type="text" name="auction_start_time" formControlName="auction_start_time" placeholder="Time"
                  class="credential2__input form-control" readonly [ngxTimepicker]="auctionStartTime"
                  [class.is-invalid]="
                    timedIndividualSubmitted &&
                    TimeIndividualControl['auction_start_time'].errors
                  " />
                <div class="invalid-feedback">
                  <p>Auction start time required.</p>
                </div>
                <ngx-material-timepicker #auctionStartTime></ngx-material-timepicker>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row mx-n2">
            <div class="col-md-6 px-2">
              <div class="form-group">
                <label for="" class="credential2__label w-100">Auction Ends</label>
                <input type="text" name="auction_end_date" formControlName="auction_end_date" placeholder="Date"
                  class="credential2__input form-control" readonly bsDatepicker [bsConfig]="{
                    showWeekNumbers: false,
                    dateInputFormat: 'DD-MM-YYYY'
                  }" [class.is-invalid]="
                    timedIndividualSubmitted &&
                    TimeIndividualControl['auction_end_date'].errors
                  " />
                <!-- [minDate]="timedAuctionForm.get('auction_start_date').value" -->
                <div class="invalid-feedback">
                  <p>Auction end date can not be blank.</p>
                </div>
              </div>
            </div>

            <div class="col-md-6 px-2">
              <div class="form-group">
                <label for="" class="credential2__label w-100 d-none d-md-inline-block">
                  &nbsp;
                </label>
                <input type="text" name="auction_end_time" formControlName="auction_end_time" placeholder="Time"
                  class="credential2__input form-control" readonly [ngxTimepicker]="auctionEndTime" [class.is-invalid]="
                    timedIndividualSubmitted &&
                    TimeIndividualControl['auction_end_time'].errors
                  " />
                <div class="invalid-feedback">
                  <p>Auction end time required.</p>
                </div>
                <ngx-material-timepicker #auctionEndTime></ngx-material-timepicker>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row mx-n2">
            <div class="col-md-6 px-2">
              <div class="form-group">
                <label for="" class="credential2__label w-100">Live Auction Starts</label>
                <input type="text" name="live_auction_start_date" formControlName="live_auction_start_date"
                  placeholder="Date" class="credential2__input form-control" readonly [style.cursor]="'not-allowed'"
                  bsDatepicker [bsConfig]="{
                    showWeekNumbers: false,
                    dateInputFormat: 'DD-MM-YYYY'
                  }" [class.is-invalid]="
                    timedIndividualSubmitted &&
                    TimeIndividualControl['live_auction_start_date'].errors
                  " />
                <div class="invalid-feedback">
                  <p>Live auction start date required.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 px-2">
              <div class="form-group">
                <label for="" class="credential2__label w-100 d-none d-md-inline-block">
                  &nbsp;
                </label>
                <input type="text" name="live_auction_start_time" formControlName="live_auction_start_time"
                  placeholder="Time" class="credential2__input form-control" readonly [style.cursor]="'not-allowed'"
                  [ngxTimepicker]="liveAuctionStartTime" [class.is-invalid]="
                    timedIndividualSubmitted &&
                    TimeIndividualControl['live_auction_start_time'].errors
                  " />
                <div class="invalid-feedback">
                  <p>Live auction start time required.</p>
                </div>
                <ngx-material-timepicker #liveAuctionStartTime></ngx-material-timepicker>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="row mx-n2">
            <div class="col-md-6 px-2">
              <div class="form-group">
                <label for="" class="credential2__label w-100">Live Auction Ends</label>
                <input type="text" name="live_auction_end_date" formControlName="live_auction_end_date"
                  placeholder="Date" class="credential2__input form-control" readonly bsDatepicker [bsConfig]="{
                    showWeekNumbers: false,
                    dateInputFormat: 'DD-MM-YYYY'
                  }" [class.is-invalid]="
                    timedIndividualSubmitted &&
                    TimeIndividualControl['live_auction_end_date'].errors
                  " />
                <!-- [minDate]="timedAuctionForm.get('live_auction_start_date').value" -->
                <div class="invalid-feedback">
                  <p>Live auction end date required.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 px-2">
              <div class="form-group">
                <label for="" class="credential2__label w-100 d-none d-md-inline-block">
                  &nbsp;
                </label>
                <input type="text" name="live_auction_end_time" formControlName="live_auction_end_time"
                  placeholder="Time" class="credential2__input form-control" readonly
                  [ngxTimepicker]="liveAuctionEndTime" [class.is-invalid]="
                    timedIndividualSubmitted &&
                    TimeIndividualControl['live_auction_end_time'].errors
                  " />
                <div class="invalid-feedback">
                  <p>Live auction end time required.</p>
                </div>
                <ngx-material-timepicker #liveAuctionEndTime></ngx-material-timepicker>
              </div>
            </div>
          </div>
        </div>

        <!-- Bidding Time Interval / Countdown Timer intentionally omitted for
             Timed Individual auctions (kept out per source, matching the
             original disabled/commented fields) -->
      </div>
    </div>
  </div>

  <!-- ============================================= -->
  <!-- SECTION: Description                           -->
  <!-- ============================================= -->
  <div class="auction-section">
    <div class="auction-section__header">
      <span class="auction-section__icon auction-section__icon--info">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.5 3.5h11M2.5 7.5h11M2.5 11.5h7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
        </svg>
      </span>
      <div class="auction-section__heading">
        <h4 class="auction-section__title">Description</h4>
        <p class="auction-section__subtitle">What bidders will read about this listing</p>
      </div>
    </div>

    <div class="auction-section__body">
      <div class="form-group mb-0">
        <textarea name="description" formControlName="description" placeholder="Type Something"
          class="credential2__textarea form-control" [class.is-invalid]="
            timedIndividualSubmitted &&
            TimeIndividualControl['description'].errors
          "></textarea>
        <div class="invalid-feedback">
          <p>Description can not be blank.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================= -->
  <!-- SECTION: Pricing (single item)                 -->
  <!-- ============================================= -->
  <div class="auction-section" *ngIf="!openBulkAuctionField">
    <div class="auction-section__header">
      <span class="auction-section__icon auction-section__icon--price">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8" cy="8" r="6.2" stroke="currentColor" stroke-width="1.3" />
          <path
            d="M8 4.6v6.8M10 6.3c0-.9-.9-1.6-2-1.6-1.1 0-2 .7-2 1.6 0 2.1 4 1 4 3.1 0 .9-.9 1.6-2 1.6-1.1 0-2-.7-2-1.6"
            stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
        </svg>
      </span>
      <div class="auction-section__heading">
        <h4 class="auction-section__title">Pricing</h4>
        <p class="auction-section__subtitle">Opening bid, floor, increment, and buy-now amount</p>
      </div>
    </div>

    <div class="auction-section__body">
      <div class="row">
        <div class="col-sm-6 col-lg-3">
          <div class="form-group">
            <label for="" class="credential2__label text-truncate w-100 mb-1">Opening Price (SAR)</label>
            <input type="text" name="opening_price" formControlName="opening_price" [inputMask]="currencyInputMask"
              placeholder="0.00" class="credential2__input form-control" [class.is-invalid]="
                (timedIndividualSubmitted &&
                  TimeIndividualControl['opening_price'].errors) ||
                invalidIndividualOpeningPrice
              " (keyup)="runValidator($event)" />
            <div class="invalid-feedback" *ngIf="!invalidIndividualOpeningPrice">
              <p>Please provide Opening price.</p>
            </div>
            <div class="invalid-feedback" *ngIf="invalidIndividualOpeningPrice">
              <p>Opening price should be greater than 0.</p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group">
            <label for="" class="credential2__label text-truncate w-100 mb-1">Lowest Price to Accept
              (SAR)</label>
            <input type="text" name="lowest_price_to_accept" formControlName="lowest_price_to_accept"
              [inputMask]="currencyInputMask" placeholder="0.00" class="credential2__input form-control"
              [class.is-invalid]="
                (timedIndividualSubmitted &&
                  TimeIndividualControl['lowest_price_to_accept'].errors) ||
                invalidIndividualLowestPriceToAccept
              " (keyup)="runValidator($event)" />
            <div class="invalid-feedback" *ngIf="!invalidIndividualLowestPriceToAccept">
              <p>Please provide Lowest price to accept.</p>
            </div>
            <div class="invalid-feedback" *ngIf="invalidIndividualLowestPriceToAccept">
              <p>
                Lowest price to Accept should be greater than or equal to Opening
                price.
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group">
            <label for="" class="credential2__label text-truncate w-100 mb-1">Incremental Value
              (SAR)</label>
            <input type="text" name="incremental_value" formControlName="incremental_value"
              [inputMask]="currencyInputMask" placeholder="0.00" class="credential2__input form-control"
              [class.is-invalid]="
                (timedIndividualSubmitted &&
                  TimeIndividualControl['incremental_value'].errors) ||
                invalidIndividualIncrementalValue
              " (keyup)="runValidator($event)" />
            <div class="invalid-feedback" *ngIf="!invalidIndividualIncrementalValue">
              <p>Please provide Incremental value</p>
            </div>
            <div class="invalid-feedback" *ngIf="invalidIndividualIncrementalValue">
              <p>Incremental Value should be grater than 0</p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group">
            <label for="" class="credential2__label text-truncate w-100 mb-1">Buy Now Price (SAR)</label>
            <input type="text" name="buy_now_price" formControlName="buy_now_price" [inputMask]="currencyInputMask"
              placeholder="0.00" class="credential2__input form-control" [class.is-invalid]="
                (timedIndividualSubmitted &&
                  TimeIndividualControl['buy_now_price'].errors) ||
                invalidIndividualBuyNowPrice2 ||
                invalidIndividualBuyNowPrice3
              " (keyup)="runValidator($event)" />
            <div class="invalid-feedback" *ngIf="
                !invalidIndividualBuyNowPrice2 && !invalidIndividualBuyNowPrice3
              ">
              <p>Please provide Buy now price</p>
            </div>
            <div class="invalid-feedback" *ngIf="invalidIndividualBuyNowPrice3">
              <p>
                Buy now price should be equal or greater than Lowest price to Accept
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================= -->
  <!-- SECTION: Custom Fields                         -->
  <!-- ============================================= -->
  <div class="auction-section">
    <div class="auction-section__header">
      <span class="auction-section__icon auction-section__icon--fields">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="3.5" width="12" height="3" rx="1" stroke="currentColor" stroke-width="1.3" />
          <rect x="2" y="9.5" width="12" height="3" rx="1" stroke="currentColor" stroke-width="1.3" />
        </svg>
      </span>
      <div class="auction-section__heading">
        <h4 class="auction-section__title">Custom Fields</h4>
        <p class="auction-section__subtitle">Optional extra attributes shown on the listing</p>
      </div>
      <div class="auction-section__headerAction">
        <button type="button" class="btn btn__util2 gray-d" (click)="addFields()">
          Add Field
        </button>
      </div>
    </div>

    <div class="auction-section__body">
      <div class="auction-create__formArray" formArrayName="fields">
        <div class="auction-create__formGroup" [formGroup]="field"
          *ngFor="let field of timeIndividualFormArray.controls; index as i">
          <div class="row mx-n2">
            <div [ngClass]="i >= 0 ? 'col-sm-5 px-2' : 'col-sm-6 px-2'">
              <div class="form-group mb-sm-0">
                <input type="text" name="entity_name" formControlName="entity_name" placeholder="Field Title"
                  class="credential2__input form-control" />
              </div>
            </div>
            <div [ngClass]="i >= 0 ? 'col-sm-5 px-2' : 'col-sm-6 px-2'">
              <div class="form-group" [ngClass]="i >= 0 ? 'mb-sm-0' : 'm-0'">
                <input type="text" name="entity_value" formControlName="entity_value" placeholder="Field Text"
                  class="credential2__input form-control" />
              </div>
            </div>

            <div class="col-sm-2 px-2" *ngIf="i >= 0">
              <button type="button" class="btn btn__main2 curved bg-red w-100" (click)="removeFields(i)">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================= -->
  <!-- SECTION: Media / Batch pricing                 -->
  <!-- ============================================= -->
  <div class="auction-section"
    *ngIf="getProductImages?.length || (openBulkAuctionField && getBatchImagesForIndividual.length)">
    <div class="auction-section__header">
      <span class="auction-section__icon auction-section__icon--media">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="3" width="12" height="10" rx="2" stroke="currentColor" stroke-width="1.3" />
          <circle cx="5.5" cy="6.5" r="1" fill="currentColor" />
          <path d="M2.5 11.5 6 8l2.5 2.5L11 8l2.5 3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
      <div class="auction-section__heading">
        <h4 class="auction-section__title">Photos</h4>
        <p class="auction-section__subtitle">Images pulled from the selected item or batch</p>
      </div>
    </div>

    <div class="auction-section__body">
      <div class="row">
        <div class="col-sm-2 col-md-2 px-2" *ngFor="let images of getProductImages">
          <div *ngIf="!openBulkAuctionField">
            <div class="form-group position-relative auction-create__auctionImages">
              <img [src]="images" alt="" class="cursor-pointer" (click)="openViewer(images)" />
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="getBatchImagesForIndividual.length">
        <div class="addBulkAuctionInIndividual px-4" [formGroup]="individualBulkAuctionForm"
          *ngIf="openBulkAuctionField">
          <div formArrayName="auctionDetails">
            <div class="auctionDetails__main" *ngFor="
                let auctionDetail of individualBukFormArray.controls;
                index as i
              " [formGroup]="auctionDetail">
              <input type="text" [(ngModel)]="getBatchImagesForIndividual?.[i].product_id" formControlName="itemId"
                hidden />

              <div class="row">
                <div class="col-12">
                  <h3 class="auctionDetails__productTitle"></h3>
                </div>

                <div class="col-sm-6 col-lg-3">
                  <div class="form-group">
                    <label for="" class="credential2__label text-truncate w-100 mb-1">Opening Price (SAR)</label>
                    <input type="text" name="opening_price" formControlName="openingPrice"
                      [inputMask]="currencyInputMask" placeholder="0.00" class="credential2__input form-control" />
                  </div>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <div class="form-group">
                    <label for="" class="credential2__label text-truncate w-100 mb-1">Lowest Price to Accept
                      (SAR)</label>
                    <input type="text" name="lowest_price_to_accept" formControlName="lowestPriceToAccept"
                      [inputMask]="currencyInputMask" placeholder="0.00" class="credential2__input form-control" />
                  </div>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <div class="form-group">
                    <label for="" class="credential2__label text-truncate w-100 mb-1">Incremental Value (SAR)</label>
                    <input type="text" name="incremental_value" formControlName="incrementalValue"
                      [inputMask]="currencyInputMask" placeholder="0.00" class="credential2__input form-control" />
                  </div>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <div class="form-group">
                    <label for="" class="credential2__label text-truncate w-100 mb-1">Buy Now Price (SAR)</label>
                    <input type="text" name="buy_now_price" formControlName="buyNowPrice"
                      [inputMask]="currencyInputMask" placeholder="0.00" class="credential2__input form-control" />
                  </div>
                </div>

                <div class="col-sm-4 col-md-4 px-2" *ngFor="let image of getBatchImagesForIndividual[i]?.imageUrl">
                  <div class="
                      form-group
                      position-relative
                      auction-create__auctionImages
                    ">
                    <img [src]="image['presigned_url']" alt="" (click)="openViewer(image['presigned_url'])"
                      class="cursor-pointer" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- ============================================= -->
  <!-- Actions                                        -->
  <!-- ============================================= -->
  <div class="row">
    <div class="col-lg-6 col-12">
      <div class="auction-create__btnGrp ml-auto mt-4" *ngIf="isActiveAuction">
        <button type="button" (click)="onEndAuction()" class="btn btn__main curved w-100 bg-danger"
          [ladda]="endAuctionLoading">
          End Auction
        </button>
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="auction-create__btnGrp ml-auto mt-4">
        <button [disabled]="(adminApprove && lockStatus) || auctionExists" type="submit"
          class="btn btn__main curved w-100" [ladda]="laddaLoading">
          {{ auctionId && isActiveAuction ? "Update" : "Create" }}
        </button>
      </div>
    </div>
  </div>
</form>